<template>
  <section class="search">
    <label class="search__form">
      Suche
      <input
        type="search"
        autocorrect="off"
        autofocus
        v-model="searchTerm">
    </label>
    <label>
      Discogs Release
      <input
        type="number"
        autocorrect="off"
        placeholder="id"
        autofocus
        v-model="searchTermDiscogsRelease">
    </label>
    <section
      v-show="resultsShow"
      class="search__results">
      <h1>Ergebnisse</h1>
      <ul>
        <li>
          <a href="#results-discogs">Discogs</a>
        </li>
        <li>
          <a href="#results-lastfm">Last FM</a>
        </li>
      </ul>
      <h2 id="results-discogs">Discogs</h2>
      <ul>
        <li
          v-for="(result, index) in searchResultDisco.album"
          :key="index">
          <a
            href="#"
            @click.prevent="getAlbumInfoDiscogs(result.masterId, result.id)">
            <img :src="result.image" alt=""><br>
            {{ result.artist }}:
            {{ result.title }} {{ result.id }}

            {{ result }}
          </a>
          <button
            @click.prevent="getAlbumInfoDiscogs(result.masterId)"
            v-if="result.masterId">Master</button>
          <button
            @click.prevent="getAlbumInfoDiscogs(null, result.id)"
            v-if="result.id">Release {{ result.id}}</button>
        </li>
      </ul>
      <h2 id="results-lastfm">LastFM</h2>
      <ul>
        <li
          v-for="(result, index) in searchResultLastFM.album"
          :key="index">
          <a
            href="#"
            @click.prevent="getAlbumInfoLastFM(result.id, result.artist, result.title)">
            <img :src="result.image" alt=""><br>
            {{ result.artist }}:
            {{ result.title }} {{ result.id }}
          </a>
        </li>
      </ul>
    </section>
    <section
      class="search__result-edit"
      v-if="selectedAlbum">
      <h2>{{ selectedAlbum.title }}</h2>
      <p>{{ selectedAlbum.artist }}</p>
      <img :src="selectedAlbum.image" alt="">
      <ol>
        <li
          v-for="track in selectedAlbum.trackList"
          :key="track.trackNumber">
          {{ track.title }} <small>{{ track.duration }}</small>
        </li>
      </ol>
      <button @click="saveAlbum">Hinzufügen</button>
      <dialog :open="saved">gespeichert</dialog>
    </section>
    <!--
    <div class="search__results">
      <section class="result__item">
        <h2>Artist</h2>
        <ul>
          <li
            v-for="(result, index) in searchResultLastFM.artist"
            :key="index">
            {{ result.name }}
          </li>
        </ul>
      </section>
    </div>
    -->
  </section>
</template>

<script>
import Discojs from 'discojs';
import dotenv from 'dotenv';
import {
  searchAlbumLastFM,
  // searchArtist,
  getAlbumInfoLastFM,
} from '@/services/lastfm.js';
import { searchAlbumDiscogs, getAlbumInfoDiscogs, getReleaseInfoDiscogs } from '@/services/discogs.js';
import { fb } from '@/services/firebase';
import { Album, albumFromSearchLastFM, albumFromSearchDiscogs, albumInfoFromDiscogs } from '@/services/AlbumModel.js';

dotenv.config();

export default {
  name: 'Search',
  data() {
    return {
      searchTerm: null,
      searchTermDiscogsRelease: null,
      searchResultLastFM: {
        album: [],
        artist: null,
      },
      searchResultDisco: {
        album: [],
        artist: null,
      },
      selectedAlbum: null,
      searchTimeout: null,
      saved: false,
    };
  },
  computed: {
    resultsShow() {
      return this.searchResultLastFM.album.length > 0
        || this.searchResultDisco.album.length > 0;
    },
  },
  async created() {
    // console.log(this.searchAlbum());
    // const result = await this.searchArtist('Dexter');
    // console.log('filter', result.filter(item => !item.mbid));
  },
  methods: {
    async searchAlbum(album) {
      // this.searchResultLastFM.album = await searchAlbumLastFM(album);
      const resultsLastFM = await searchAlbumLastFM(album);
      this.searchResultLastFM.album = [];
      resultsLastFM.forEach((albumPreview) => {
        this.searchResultLastFM.album.push(albumFromSearchLastFM(albumPreview));
      });

      // const resultsDisco = await disco.searchRelease(album);
      const resultsDisco = await searchAlbumDiscogs(album);
      this.searchResultDisco.album = [];
      resultsDisco.forEach((albumPreview) => {
        this.searchResultDisco.album.push(albumFromSearchDiscogs(albumPreview));
      });
    },
    async searchRelease(id) {
      const resultDiscoRelease = await getReleaseInfoDiscogs(id);
      console.log(resultDiscoRelease)
      this.searchResultDisco.album = [];
      this.searchResultDisco.album.push(albumFromSearchDiscogs(resultDiscoRelease));
    },
    /*
    searchArtist(artist) {
      return searchArtist(artist);
    },
    */
    async getAlbumInfoDiscogs(masterId, id) {
      let albumInfo = null;
      let albumInfoTransformed = null;
      if (masterId) {
        albumInfo = await getAlbumInfoDiscogs(masterId);
        albumInfoTransformed = await albumInfoFromDiscogs(albumInfo);
      } else {
        albumInfo = await getReleaseInfoDiscogs(id);
        albumInfoTransformed = await albumInfoFromDiscogs(albumInfo);
      }
      this.selectedAlbum = { ...albumInfoTransformed };
    },
    async getAlbumInfoLastFM(id, artist, album) {
      let albumInfo = null;
      let albumInfoTransformed = null;

      albumInfo = await getAlbumInfoLastFM(id, artist, album);
      albumInfoTransformed = new Album().convertAlbumInfoFromLastFm(albumInfo);

      this.selectedAlbum = { ...albumInfoTransformed };
    },
    async saveAlbum() {
      const data = JSON.parse(JSON.stringify(this.selectedAlbum));
      // fb.firestore().collection('album').add(data)
      fb.firestore().collection('album').doc(data.id).set(data)
        .then(() => {
          this.saved = true;
          setTimeout(() => {
            this.saved = false;
          }, 2000);
        })
        .catch((error) => {
          console.error('Error adding document: ', error);
        });
    },
  },
  watch: {
    searchTerm(value) {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.searchAlbum(value), 1000);
    },
    searchTermDiscogsRelease(value) {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.searchRelease(value), 1000);
    },
  },
};
</script>

<style scoped lang="scss">
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  img {
    height: auto;
    max-width: 100%;
  }

  .search {
    --spacing: 1em;

    display: grid;

    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    hyphens: auto;

    @media (min-width: 700px) {
      grid: 'search .' auto
            'result edit' auto
      / 1fr 1fr;
      padding: 0 var(--spacing);
      grid-gap: var(--spacing);
    }

    &__form {
      @media (min-width: 700px) {
        grid-area: search;
      }
    }

    &__results {
      order: 2;

      @media (min-width: 700px) {
        grid-area: result;
      }
    }

    &__result-edit {
      order: 1;

      @media (min-width: 700px) {
        grid-area: edit;
      }
    }
  }
</style>
